import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Accordion from "./Accordion";
import { FaBars } from "react-icons/fa";

const SandwichBtn = styled.div`
  color: #e5e5e5;
  font-size: 26px;
  height: 100%;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const SideBar = styled.nav`
  display: flex;
  flex-direction: column;
  width: 270px;
  text-align: left;
  overflow: hidden;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transition: transform 0.3s ease-in-out;
  background: #151e3d;
  z-index: 3;
  padding: 25px 0;

  transform: ${({ isOpen }) =>
    isOpen ? "translateX(0) " : "translateX(-100%)"};

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #151e3d;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const SideBarItem = styled.div`
  text-transform: uppercase;
  font-size: 17px;
  padding: 0 20px;
  margin-bottom: 30px;
  font-weight: 700;
  text-decoration: none;
  transition: color 0.3s linear;
  color: white;
  cursor: pointer;

  &:hover {
    color: #3fa9f5;
  }
`;

const BurgerMenu = React.forwardRef(({ items, isOpen, setIsOpen }, ref) => {
  return (
    <div ref={ref}>
      <SandwichBtn data-test="sandwich-btn" onClick={() => setIsOpen(!isOpen)}>
        <FaBars />
      </SandwichBtn>
      <SideBar data-test="sidebar" isOpen={isOpen}>
        {items.map((item, idx) =>
          item.isMenu ? (
            <Accordion
              key={idx}
              title={item.title}
              accordionItems={item.menuItems}
            ></Accordion>
          ) : (
            <SideBarItem key={idx}>{item.title}</SideBarItem>
          )
        )}
      </SideBar>
    </div>
  );
});

BurgerMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      menuItems: PropTypes.arrayOf(PropTypes.string),
      isMenu: PropTypes.bool,
    })
  ).isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default BurgerMenu;
